import React, { useState, useCallback } from 'react';

import ResponseData from './AppointeeResponse/ResponseData/ResponseData.container';
import Menu from './Menu/Menu';

const GenericAppointeeManagementContainer = () => {
	const [{ activeMenu, activeMenuProps }, setActive] = useState({ activeMenu: '', activeMenuProps: null });
	const handleMenuChange = useCallback((menuToOpen, menuProps) => {
        setActive({ activeMenu: menuToOpen, activeMenuProps: menuProps });
	}, []);

    switch (activeMenu) {
        case 'appointee_contract_response': {
            return <ResponseData onClose={handleMenuChange} {...activeMenuProps} />;
        }
        default:
            return (
				<Menu onChange={handleMenuChange} />
            );
    }
};

export default GenericAppointeeManagementContainer;
